import { BASE_API_URL } from './index';

export const apiTokenEndpoint = (companyId) => `${BASE_API_URL}/companies/${companyId}/api_tokens/`;
export const deleteApiTokenEndpoint = (companyId, tokenId) => `${apiTokenEndpoint(companyId)}${tokenId}/`;
export const regenerateApiTokenEndpoint = (companyId, tokenId) =>
  `${deleteApiTokenEndpoint(companyId, tokenId)}regenerate/`;
